var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0443 8.50955V7.04435C19.0443 3.15386 15.8905 0 12 0C8.10951 0 4.9557 3.15386 4.9557 7.0443V8.5095C3.10487 9.45402 1.93897 11.3556 1.93671 13.4335V18.4652C1.94006 21.5206 4.4161 23.9967 7.47151 24H16.5285C19.5839 23.9966 22.06 21.5206 22.0633 18.4652V13.4335C22.0611 11.3556 20.8952 9.45402 19.0443 8.50955ZM12 3.01899C14.2231 3.01899 16.0253 4.82119 16.0253 7.0443V7.89868H7.97469V7.0443C7.97469 4.82119 9.77689 3.01899 12 3.01899ZM19.0443 18.4652C19.0443 19.8546 17.918 20.981 16.5285 20.981H7.47156C6.08211 20.981 4.95575 19.8546 4.95575 18.4652V13.4335C4.95575 12.0441 6.08211 10.9177 7.47156 10.9177H16.5285C17.918 10.9177 19.0443 12.0441 19.0443 13.4335V18.4652Z",
    fill: "#E90064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4969 13.9366H12.5032C13.3369 13.9366 14.0127 14.6125 14.0127 15.4461C14.0127 16.2798 13.3369 16.9556 12.5032 16.9556H11.4969C10.6633 16.9556 9.98743 16.2798 9.98743 15.4461C9.98743 14.6125 10.6633 13.9366 11.4969 13.9366Z",
    fill: "#E90064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_1666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockRed);
export default __webpack_public_path__ + "static/media/lock_red.fb2a2530ffbaa8b32441cf9ce09b3af6.svg";
export { ForwardRef as ReactComponent };